import { Component, DestroyRef, inject, OnDestroy, OnInit, signal, ViewChild, computed } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StandardQuoteService } from '../../standard-quote-service.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import {
  quoteDto,
  quoteRequestDto,
  grace,
  specialPayments,
  modelTypeEnum,
  models,
  FinancialProductEnum, dealsDto,
  customerDto,
} from '../../model/standard-quote.model';
import { BaseComponent } from '@app/components/base/base.component';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';
import { FinancialProductWrapperComponent } from '../financial-product/financial-product-wrapper.component';
import { environment } from '@env/environment.local';
import { BodyCalculate, Deal } from '../../model/model-body.model';
import { Constants } from '@app/constants/Constants';
import { TranslateService } from "@ngx-translate/core";
import { of, catchError, concatMap, Subject, BehaviorSubject, forkJoin, Observable, take, interval, timer, debounce, debounceTime, switchMap } from 'rxjs';
import { AuthService } from '@app/common/auth.service';
import { MessagesUtil } from "@app/core/model/Message";
import {
  InsuranceService,
  InsuranceTypeEnum,
  isLifeInsuranceEligible,
  LIFE_INSURANCE_FACTOR,
  resolveFinancedUnitInsurancePremium,
} from '@app/services/insurance.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ICommonInsuranceParams, ICommonModelInsurance, QuoteType } from '@app/pages/quote/insurance/insurance-model';
import { createLoadingTracker } from '@app/core/util/loading-tracker';
import { isFinancialSetupCompanyMismatchForQuote } from '../../../open-quote/model/open-quote.model';

@Component({
  template: ''
})
export class NewDealStandardQuoteWrapperComponent
  extends BaseComponent
  implements OnInit, OnDestroy {
  readonly insuranceService = inject(InsuranceService);
  private readonly authService = inject(AuthService);
  public readonly quoteService = inject(StandardQuoteService);
  private readonly translateService = inject(TranslateService);
  private readonly fb = inject(FormBuilder);
  private readonly router = inject(Router);

  idDeal: any;
  id: any;
  private readonly loading = createLoadingTracker();
  isLoading = computed(() => this.loading.count() > 0);
  form: FormGroup;
  dataService: quoteDto | null;
  showSection: number = 1;
  coverageResult: any;
  postalCode: string;
  activarBotonJson =
    environment.downloadJson ||
    this.authService.checkRoleFromParentMenu('cotizador0', 'ADMINISTRATOR');
  models: models | undefined = this.quoteService.formData?.model;
  financialProduct = FinancialProductEnum;
  originalTerm: any = null;
  showMessageCalculate: boolean = false;
  private _commonInsurance: ICommonInsuranceParams =
    {} as ICommonInsuranceParams;
  private _modelInsurance: ICommonModelInsurance = {} as ICommonModelInsurance;
  public readonly quoteType = QuoteType.STANDARD;
  _firstLoad = true;
  _originalInsurance: any;
  _insuranceSubscription: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private _calculationScheduled = false;
  private _calculationExecuted = false;
  private temporalPayments = signal<any[]>([]);
  private temporalInsurancePayments = signal<any>([]);
  /** Si es true, al guardar se deben ejecutar los delete de seguro, gracia y pagos especiales (solo se limpió el form al confirmar "Eliminar"). */
  private _dealPaymentsInsurancePendingDeletion = false;
  private _pendingDeletionInsuranceId: number | null = null;

  constructor(
    route: ActivatedRoute,
    menuService: MenusServices,
    notification: NotificationService,
  ) {
    super(route, menuService, notification);
  }

  @ViewChild(FinancialProductWrapperComponent)
  financialProductComponent!: FinancialProductWrapperComponent;

  ngOnInit() {
    this.createForm();
    this.dataService = this.quoteService.formData;
    this.route?.paramMap.subscribe((params) => {
      this.id = params.get('id');
      this.idDeal = params.get('idDeal');
      if (this.idDeal) {
        // edicion
        this.getById();
        this.updateInsuranceData();
        this._insuranceSubscription.next(this._originalInsurance);
      } else {
        if (this.quoteService.duplicateDeal) {
          let deal = {
            ...this.quoteService.duplicateDeal,
            financialSetup: {
              ...this.quoteService.duplicateDeal.financialSetup,
              financialCondition: this.quoteService.duplicateDeal.financialCondition,
            },
            standardFinancialSetup: {
              ...this.quoteService.duplicateDeal.standardFinancialSetup,
            },
            grace: this.quoteService.duplicateDeal.grace,
            specialPayments: this.quoteService.duplicateDeal.specialPayments,
            irregularPayments: this.quoteService.duplicateDeal.irregularPayments,
            result: null,
            payments: [],
            insurance:  this.quoteService.duplicateDeal.insurance ? this.quoteService.duplicateDeal.insurance : null,
            insuranceDeals: [],
            clonedPendingRecalculate:
              this.quoteService.duplicateDeal.clonedPendingRecalculate === true,
          };
          this.form.patchValue(deal);
          // Ejecutar cálculo automáticamente después del clonado
          this.waitForDataAndCalculate();
        }
      }
    });
    this.form.controls['financialSetup'].valueChanges
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe(() => {
        this.updateInsuranceData();
      });
    this.form.controls['financialCondition'].valueChanges
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe(() => {
        this.updateInsuranceData();
      });

    // Setup insurance subscription
    this._insuranceSubscription
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((insurance) => {
        if (insurance) {
          this.insuranceService.setInsuranceForm.next(insurance);
        }
      });

    // interval(10000).pipe(takeUntilDestroyed(this._destroyRef)).subscribe(()=>{
    //   console.log("Validando FORM");
    //   console.log("Validacion del valor isValid: ", { getRawValue: this.form.getRawValue() });
    //   for (const key in this.form.controls) {
    //     const control = this.form.controls[key];
    //     if (control.invalid) {
    //       console.log(`El campo ${key} tiene el siguiente error:`, control.errors);
    //     }
    //   }
    //   console.log("FIN validacion")
    // });
  }


  ngOnDestroy() {
    this.insuranceService.showInsurance.set(false);
    this.insuranceService.insuranceParams.set(null);
    this.insuranceService.insuranceModel.set(null);
    this.insuranceService.dealerId.set(null);
    this.insuranceService.dealerBranchId.set(null);
  }

  getById() {
    if (!this.quoteService.formData) return;
    let deal: any;
    if (this.dataService && !this.quoteService.duplicateDeal) {
      deal = this.quoteService.formData?.standardQuoteDeals.find(
        (i) => i.id == this.idDeal
      );
      let result = this.quoteService.formData?.standardQuoteDeals.map(
        (dealDto) => {
          return {
            ...dealDto,
            isFinancialSetupInactive: dealDto.isFinancialSetupInactive,
            isFinancialSetupCompanyMismatch: dealDto.isFinancialSetupCompanyMismatch,
            financialSetup: {
              ...dealDto.financialSetup,
              openingFee: dealDto.standardFinancialSetup.openingFee,
              openingFeeTax: dealDto.standardFinancialSetup.openingFeeTax,
              balloon: dealDto.standardFinancialSetup.balloon,
              balloonPercentage:
                dealDto.standardFinancialSetup.balloonPercentage,
              downPaymentTax: dealDto.standardFinancialSetup.downPaymentTax,
              downPayment: dealDto.standardFinancialSetup.downPayment,
            },
            financialCondition: dealDto.financialCondition,
            standardQuoteConditions: dealDto.standardQuoteCondition,
            standardFinancialSetup: dealDto.standardFinancialSetup,
          };
        }
      );
      this.quoteService.formData.standardQuoteDeals = result;
      // El merge vive en `result`; `deal` seguía siendo la fila del array anterior (financialSetup con null del catálogo).
      deal =
        result.find(
          (i: any) => i.id == this.idDeal || String(i.id) === String(this.idDeal)
        ) ?? deal;
    }
    this.form.patchValue(deal);
    this._dealPaymentsInsurancePendingDeletion = false;
    this._pendingDeletionInsuranceId = null;
    if (deal.insurance) {
      this._originalInsurance = deal.insurance;
    }
    //check isFinancialSetupInactive is true
    if (!deal.financialSetup.active) {
      this.showNotificationError(MessagesUtil['FINANCIAL_SETUP_INACTIVE']);
    } else if (
      deal.isFinancialSetupCompanyMismatch === true ||
      isFinancialSetupCompanyMismatchForQuote(
        deal.financialSetup?.companyName,
        this.quoteService.formData?.companyName,
      )
    ) {
      this.showNotificationError(MessagesUtil['FINANCIAL_SETUP_COMPANY_MISMATCH']);
    }

    this.postalCode = deal?.insurance?.postalCode;
  }

  createForm() {
    this.form = this.fb.group({
      id: [this.idDeal, [Validators.required]],
      isSelected: [false, []],
      financialSetup: [, [Validators.required]],
      grace: [[], []],
      specialPayments: [[], []],
      payments: [[], []],
      result: [, []],
      insurance: [, []],
      financialCondition: [, [Validators.required]],
      comment: [, []],
      wholeSale: [, []],
    });
    this.updateInsuranceData();
    this.form.controls['insurance'].valueChanges.pipe(takeUntilDestroyed(this._destroyRef), debounceTime(250)).subscribe((value) => {
      const showIns = this.insuranceService.showInsurance();
      if (value !== null && !showIns) {
        this.resetInsurance('a');
        this.form.controls['insurance'].updateValueAndValidity();
      }
    });
  }

  cancel() {
    if (this.id) {
      this.router.navigate([`standard-quote/edit-quote/${this.id}`]);
      this.updateInsuranceData(); // TODO: CHECKEABLE
      this.quoteService.formData = null;
    } else {
      this.router.navigate([`quote/standard-quote/new-quote`]);
    }
  }

  setValueInService() {
    const rawValue = this.form.getRawValue();
    if (this.idDeal && this.dataService) {
      const index = this.dataService.standardQuoteDeals.findIndex(
        (i) => i.id == this.idDeal
      );
      this.dataService.standardQuoteDeals[index] = rawValue;
    } else {
      this.dataService?.standardQuoteDeals.push(rawValue);
    }
    this.quoteService.formData = this.dataService;
  }

  calculate() {
    // if (this._calculationExecuted) {
    //   return;
    // }

    this._calculationExecuted = true;
    this.form.controls['result'].setValue(null);
    const formRaw = this.form.getRawValue();
    const insurance = this.form.controls['insurance'].value;
    const insuranceType = insurance?.insuranceType;
    const hasMarshInsurancePayments = (insuranceType == InsuranceTypeEnum.FINANCED_ANNUAL || insuranceType == InsuranceTypeEnum.FINANCED_MULTIYEAR);
    const hasPackageList = insurance?.packageList != null && insurance?.packageList?.coverageListModel != null && insurance?.packageList?.coverageListModel?.length > 0;

    if (hasMarshInsurancePayments && hasPackageList) {
      this.handleCalculateQuoteWithInsurance();
    } else {
      this.handleCalculateQuoteWithoutInsurance();
    }
  }

  private handleCalculateQuoteWithInsurance() {
    const models: any = this.quoteService.formData?.model;
    const standardQuoteModel = this.quoteService.formData?.standardQuoteModel;
    const customer: any = this.quoteService.formData?.customer;

    const quoteCalculation = this.quoteService.calculateQuote(
      this.form.getRawValue(),
      models,
      customer,
      standardQuoteModel
    );
    const insuranceAmortizations = this.createCalculateInsuranceAmortization(customer);
    this.loading.track(forkJoin([quoteCalculation, insuranceAmortizations])).subscribe({
      next: ([quoteResponse, insuranceResponse]) => {
        if (!this.handleQuoteResponse(quoteResponse) || !this.handleMarshInsuranceResponse(insuranceResponse)) {
          return;
        }
        this.processMarshPayments(quoteResponse, insuranceResponse);
      },
      error: (e) => this.handleQuoteResponse(e)
    });
  }

  private processMarshPayments(quoteResponse: any, insuranceResponse: any) {
    const payments = this.temporalPayments()?.length > 0 ? this.temporalPayments() : this.form.controls['payments'].value || [];
    const idDeal = this.form.controls['id'].value;
    const insurance = this.form.controls['insurance'].value;
    const insurancePayments = this.temporalInsurancePayments()?.length > 0 ? this.temporalInsurancePayments() : insurance?.standardQuoteInsurancePayments || [];
    const deleteOperations = this.buildDeleteOperations(payments, idDeal, insurancePayments, insurance?.id);

    if (deleteOperations.length > 0) {
      this.temporalPayments.set([]);
      this.temporalInsurancePayments.set([]);
      this.loading.track(forkJoin(deleteOperations)).subscribe({
        next: () => {
          this.assignMarshPayments(insuranceResponse);
          this.assignResult(quoteResponse.data[0]);
        },
        error: () => this.handleCalculationError()
      });
    } else {
      this.assignMarshPayments(insuranceResponse);
      this.assignResult(quoteResponse.data[0]);
    }
  }

  private buildDeleteOperations(payments: any[], idDeal: any, insurancePayments: any[], insuranceId: any): Observable<any>[] {
    const deleteOperations = [];

    if (payments?.length > 0 && idDeal != null) {
      deleteOperations.push(this.deleteStandardQuotePayments(idDeal));
    }

    if (insurancePayments?.length > 0 && !!idDeal && !!insuranceId) {
      deleteOperations.push(this.deleteMarshInsurancePaymentsRefactor(idDeal, insuranceId));
    }

    return deleteOperations;
  }

  saveTemporalPayments(idDeal: number, insuranceId: number, payments: any[], insurancePayments: any[]) {
    let savePayment = false;
    let saveInsurancePayments = false;
    if (payments?.length > 0 && idDeal != null) {
      this.temporalPayments.set(payments);
      savePayment = true;
    }

    if (insurancePayments?.length > 0 && !!idDeal && !!insuranceId) {
      this.temporalInsurancePayments.set(insurancePayments);
      saveInsurancePayments = true;
    }

    return { savePayment, saveInsurancePayments };
  }

  private assignMarshPayments(insuranceResponse: any) {
    const insurance = this.form.controls['insurance'].value;
    const { insuranceResult, payments } = this.insuranceService.getMappedAmortization(insuranceResponse);
    Object.entries(insuranceResult).forEach(([key, value]) => {
      insurance[key] = value;
    });
    insurance["standardQuoteInsurancePayments"] = payments;
    this.form.controls['insurance'].setValue(insurance);
  }

  private deleteMarshInsurancePaymentsRefactor(idDeal: number, idInsurance: number) {
    return this.insuranceService.deleteMarshInsurancePaymentsStandard(this.id, idDeal, idInsurance).pipe(take(1));
  }

  deleteStandardQuotePayments(idDeal: number) {
    return this.quoteService.deletePayments(this.id, idDeal)
  }

  private handleCalculationError() {
    this.showNotificationError(
      'Ha ocurrido un error al momento de realizar el calculo. Por favor, intente nuevamente o solicite soporte.'
    );
  }

  private handleCalculateQuoteWithoutInsurance() {
    const models: any = this.quoteService.formData?.model;
    const standardQuoteModel = this.quoteService.formData?.standardQuoteModel;
    const customer: any = this.quoteService.formData?.customer;
    const temporalPayments = this.temporalPayments()?.length > 0 ? this.temporalPayments() : this.form.controls['payments'].value || [];
    this.loading.track(
      this.quoteService
        .calculateQuote(
          this.form.getRawValue(),
          models,
          customer,
          standardQuoteModel
        ))
      .subscribe({
        next: (response) => {
          this.showMessageCalculate = false;
          //timeout
          const success = this.handleQuoteResponse(response);
          if (!success) {
            return;
          }
          if (temporalPayments.length > 0 && this.idDeal != null) {
            this.temporalPayments.set([]);
            this.deletePayments(response.data[0]);
          } else {
            this.assignResult(response.data[0]);
          }
          if (!!this.form.controls["insurance"].value) {
            this.updateInsuranceData(); // TODO: CHECKEABLE
          }
        },
        error: () => {
          this.showNotificationError(
            'Ha ocurrido un error al momento de calcular.'
          );
        },
      });
  }

  private handleQuoteResponse(response: any): boolean {
    if (!response.status && response.error === Constants.QUOTE_ERROR_PROCOTIZA_TIME_OUT_INTEGRATION) {
      this.showNotificationError(
        this.translateService.instant(Constants.QUOTE_ERROR_PROCOTIZA_TIME_OUT_INTEGRATION)
      );
      return false;
    } else if (!response.status && response.error && response.error.Detalle) {
      this.showNotificationError(response.error.Detalle);
      return false;
    } else if (!response.status) {
      const error = response.errors?.[0] ?? '';
      if (error.includes('calculo de periodo de gracia')) {
        this.showNotificationError(
          error
        );
      } else {
        this.showNotificationError(
          'Ha ocurrido un error al momento de realizar el calculo. Por favor, intente nuevamente o solicite soporte.'
        );
      }
      this.showMessageCalculate = false;
      return false;
    }

    return true;
  }


  private createCalculateInsuranceAmortization(customer: customerDto) {
    const insurance = this.form.controls['insurance'].value;
    let model: any = this.quoteService.getBodyforStandardQuoteCalculateInsuranceMarsh(
      insurance,
      this.insuranceService.insuranceParams()!,
      customer,
      this.form.getRawValue()
    );
    return this.insuranceService.createInsuranceAmortization(model);
  }
  private handleMarshInsuranceResponse(insuranceResponse: any): boolean {
    if (insuranceResponse.error) {
      const message = insuranceResponse.needTranslate ? this.translateService.instant(insuranceResponse.message) : insuranceResponse.message;
      this.showNotificationError(message);
      return false;
    }

    return true;
  }

  save(redirection?: boolean) {
    const id = this.quoteService.formData?.id;
    if (id) {
      this.update(id, redirection);
    } else {
      this.saveDraft();
    }
  }

  updateSpecialPayments(specialPayments: specialPayments[]) {
    this.form.controls['specialPayments'].setValue(specialPayments);
    this.calculate();
  }

  updateGrace(grace: grace[]) {
    this.form.controls['grace'].setValue(grace);
    this.calculate();
  }

  update(id: number, redirection?: boolean) {
    if (redirection) {
      this.setValueInService();
    }
    let update$ = this.quoteService.dealsClearedByCompanyChange
      ? this.quoteService.deleteAllDeals(this.id).pipe(
          switchMap(() => this.quoteService.updateQuote(id))
        )
      : this.quoteService.updateQuote(id);

    if (this._dealPaymentsInsurancePendingDeletion) {
      update$ = this.executePendingDeletionApi().pipe(
        switchMap(() => this.quoteService.updateQuote(id))
      );
    }

    this.loading.track(update$).subscribe({
      next: (response) => {
        this.setResponseOnForm(response.data);
        if (redirection) {
          this.cancel();
          this.quoteService.formData = null;
        }
      },
      error: (error) => {
        this.showNotificationError(
          'Ha ocurrido un error al momento de guardar.'
        );
      },
    });
  }

  saveDraft() {
    this.loading.track(this.quoteService.saveDraft()).subscribe({
      next: (response) => {
        // if (response.status == false) {
        // this.showNotificationError(
        //   'Ha ocurrido un error al momento de guardar.'
        // );
        // }

        this.setResponseOnForm(response.data);
      },
      error: (error) => {
        this.showNotificationError(
          'Ha ocurrido un error al momento de guardar.'
        );
      },
    });
  }

  setResponseOnForm(response: quoteRequestDto) {
    if (!this.dataService) return;
    this.id = response.id;
    this.dataService.id = response.id;
    this.dataService.quantity = response.quantity;
    this.dataService.creationDate = response.creationDate;
    this.dataService.updatedDate = response.updatedDate;
    this.dataService.creationUser = response.creationUser;
    this.dataService.status = response.status;
    this.dataService.dealAmount = response.dealAmount;
    const previousCustomer = this.dataService.customer;
    this.dataService.customer = {
      ...response.customer,
      rfc: response.customer?.rfc ?? previousCustomer?.rfc,
    };
    response.model.priceType = response.standardQuoteModel.priceType;
    response.model.price = response.standardQuoteModel.price;
    const savedCurrency = response.standardQuoteModel?.currency;
    if (savedCurrency != null && savedCurrency !== '') {
      response.model.currency = savedCurrency;
    }
    this.dataService.model = response.model;
    this.dataService.standardQuoteModel = response.standardQuoteModel;
    this.dataService.accessories = response.accessories;
    let responseDeals = response.standardQuoteDeals ?? [];
    if (this.quoteService.dealsClearedByCompanyChange && responseDeals.length > this.dataService.standardQuoteDeals?.length) {
      const n = this.dataService.standardQuoteDeals?.length ?? 0;
      responseDeals = responseDeals.slice(-n);
    }
    this.dataService.standardQuoteDeals = this.setValueDownpaymentAndOpeningfee(responseDeals);
    if (this.idDeal) {
      const deal = this.dataService.standardQuoteDeals.filter(
        (i) => i.id == this.idDeal
      )[0];
      this.form.patchValue(this.setValue(deal));
    } else {
      let lengthDeals = this.dataService.standardQuoteDeals.length - 1;
      this.form.patchValue(
        this.setValue(this.dataService.standardQuoteDeals[lengthDeals])
      );
    }
    this.idDeal = this.form.controls['id'].value;
    this.quoteService.formData = this.dataService;
    if (this.quoteService.dealsClearedByCompanyChange) {
      this.quoteService.dealsClearedByCompanyChange = false;
    }
    this._dealPaymentsInsurancePendingDeletion = false;
    this._pendingDeletionInsuranceId = null;
    this.updateInsuranceData(); // TODO: CHECKEABLE
  }

  selectSection(index: number) {
    this.showSection = index;
  }

  setCondition(condition: any) {
    if (!this.originalTerm) {
      this.originalTerm = condition.term;
    }

    if (this.originalTerm && this.originalTerm !== condition.term) {
      this.form.updateValueAndValidity({ onlySelf: true });
      this.form.controls['payments'].setValue([]);
      this.form.controls['result'].setValue(null);
      this.showMessageCalculate = true;
    }
    this.form.controls['financialCondition'].setValue(condition);
  }

  /** Tras confirmar cambio de parámetros de seguro (tipo, estado, uso, pasajeros…): limpia solo amortización del seguro (no la del paquete). */
  onInsuranceSensitiveFieldsConfirm(): void {
    this.temporalInsurancePayments.set([]);
    const insurance = this.form.controls['insurance'].value;
    if (insurance != null) {
      this.form.controls['insurance'].setValue({
        ...insurance,
        standardQuoteInsurancePayments: [],
      });
    }
    this.showMessageCalculate = true;
  }

  deletePayments(result: quoteDto) {
    this.callDeletePayments().subscribe({
      next: () => {
        this.assignResult(result);
      },
      error: () => { },
    });
  }

  callDeletePayments(): Observable<any> {
    const id = this.form.controls['id'].value;
    return this.loading.track(this.quoteService.deletePayments(this.id, id));
  }

  setValue(deal: any) {
    let newValues = {
      id: deal.id,
      isSelected: deal.isSelected,
      grace: deal.grace,
      specialPayments: deal.specialPayments,
      payments: deal.payments,
      result: deal.result,
      insurance: deal.insurance,
      comment: deal.comment,
    };
    return newValues;
  }

  assignResult(result: any) {
    this.form.controls['result'].setValue({
      term: result.term,
      unitPrice: result.unitPrice,
      unitPriceNoTax: result.unitPriceNoTax,
      annualPercentageRate: result.annualPercentageRate,
      downpaymentAmount: result.downpaymentAmount,
      openingfeeAmount: result.openingfeeAmount,
      balloonAmount: result.balloonAmount,
      guaranteeDepositAmount: result.guaranteeDepositAmount,
      insuranceAmount: result.insuranceAmount,
      additionalServicesAmount: result.additionalServicesAmount,
      confirmationExpensesAmount: result.confirmationExpensesAmount,
      initialPayment: result.initialPayment,
      financialAmount: result.financialAmount,
      monthlyPayment: result.monthlyPayment,
      annualTotalCost: result.annualTotalCost,
      purchaseOptionAmount: result.purchaseOptionAmount,
      residualValue: result.residualValue,
    });
    this.form.controls['payments'].setValue(result.payments);
    this.setValueInService();
    this.save();
  }

  /**
   * Solo limpia el form (seguro, gracia, pagos especiales, amortizaciones). No llama al API.
   * Las eliminaciones en backend se ejecutan al guardar (update) si _dealPaymentsInsurancePendingDeletion.
   */
  deleteAllPayments() {
    const insurance = this.form.controls['insurance'].value;
    if (insurance?.id != null) {
      this._pendingDeletionInsuranceId = insurance.id;
    } else {
      this._pendingDeletionInsuranceId = null;
    }
    this._dealPaymentsInsurancePendingDeletion = true;

    this.form.controls['grace'].setValue([]);
    this.form.controls['specialPayments'].setValue([]);
    this.form.controls['insurance'].setValue(null);
    this.form.controls['payments'].setValue([]);
    this.form.controls['result'].setValue(null);
    this.temporalPayments.set([]);
    this.temporalInsurancePayments.set([]);
    this.insuranceService.resetForm.next();
    this.form.updateValueAndValidity();
    this.showNotificationSuccess(
      'Se eliminaron correctamente los períodos de gracia, pagos especiales y seguros asociados a la propuesta.'
    );
  }

  /** Ejecuta en backend delete de seguro, gracia y pagos especiales (para aplicar al guardar). */
  private executePendingDeletionApi(): Observable<unknown> {
    let deleteInsurance$: Observable<unknown> = of(null);
    if (this._pendingDeletionInsuranceId != null) {
      deleteInsurance$ = this.quoteService
        .deleteInsurance(this.id, this.idDeal, this._pendingDeletionInsuranceId)
        .pipe(
          catchError(() => {
            this.showNotificationError(
              'Ha ocurrido un error en el borrado de seguro. Vuelva a intentarlo.'
            );
            return of(null);
          })
        );
    }
    return deleteInsurance$.pipe(
      concatMap(() =>
        this.quoteService.deleteAllGracePeriod(this.id, this.idDeal).pipe(
          catchError(() => {
            this.showNotificationError(
              'Ha ocurrido un error en el borrado del período de gracia. Vuelva a intentarlo.'
            );
            return of(null);
          })
        )
      ),
      concatMap(() =>
        this.quoteService.deleteAllSpecialPayments(this.id, this.idDeal).pipe(
          catchError(() => {
            this.showNotificationError(
              'Ha ocurrido un error en el borrado de pagos especiales. Vuelva a intentarlo.'
            );
            return of(null);
          })
        )
      )
    );
  }

  deleteAllGracePeriod(hasSpecialPayments: boolean) {
    this.loading.track(this.quoteService.deleteAllGracePeriod(this.id, this.idDeal)).subscribe({
      next: (response) => {
        if (!hasSpecialPayments) {
          this.form.controls['grace'].setValue([]);
          this.form.updateValueAndValidity();
          this.showNotificationSuccess(
            'Períodos de gracia han sido eliminados correctamente.'
          );
        } else {
          this.deleteAllSpecialPayments(true);
        }
      },
      error: (error) => {
        this.showNotificationError(
          'Ha ocurrido un error. Vuelva a intentarlo.'
        );
      },
    });
  }

  deleteAllSpecialPayments(hasPeriodGrace?: boolean) {
    this.loading.track(this.quoteService.deleteAllSpecialPayments(this.id, this.idDeal)).subscribe({
      next: (response) => {
        if (!hasPeriodGrace) {
          this.showNotificationSuccess(
            'Pagos especiales han sido eliminados correctamente.'
          );
          this.form.controls['specialPayments'].setValue([]);
        } else {
          this.form.controls['grace'].setValue([]);
          this.form.controls['specialPayments'].setValue([]);
          this.showNotificationSuccess(
            'Pagos especiales y períodos de gracia han sido eliminados correctamente.'
          );
        }
      },
      error: (error) => {
        this.showNotificationError(
          'Ha ocurrido un error. Vuelva a intentarlo.'
        );
      },
    });
  }

  setValueDownpaymentAndOpeningfee(deals: any) {
    let newDeals = deals.map((i: any) => {
      return {
        ...i,
        financialSetup: {
          ...i.financialSetup,
          // Prefer current financialSetup values (user-edited) over legacy top-level fields.
          downPayment: i.financialSetup?.downPayment ?? i.downPayment ?? i.standardFinancialSetup?.downPayment,
          downPaymentTax: i.financialSetup?.downPaymentTax ?? i.downPaymentTax ?? i.standardFinancialSetup?.downPaymentTax,
          downPaymentTaxType: i.financialSetup?.downPaymentTaxType ?? i.downPaymentTaxType ?? i.standardFinancialSetup?.downPaymentTaxType,
          openingFee: i.financialSetup?.openingFee ?? i.openingFee ?? i.standardFinancialSetup?.openingFee,
          openingFeeTax: i.financialSetup?.openingFeeTax ?? i.openingFeeTax ?? i.standardFinancialSetup?.openingFeeTax,
          openingFeeTaxType: i.financialSetup?.openingFeeTaxType ?? i.openingFeeTaxType ?? i.standardFinancialSetup?.openingFeeTaxType,
          termId: i.financialCondition.id,
          balloon: i.balloon ?? i.financialSetup?.balloon ?? i.standardFinancialSetup?.balloon,
          balloonPercentage: i.balloonPercentage ?? i.financialSetup?.balloonPercentage ?? i.standardFinancialSetup?.balloonPercentage,
          balloonType: i.balloonType ?? i.financialSetup?.balloonType ?? i.standardFinancialSetup?.balloonType,
        },
      };
    });
    return newDeals;
  }

  resetInsurance(_e: unknown) {
    this.form.controls['insurance'].setValue(null);
    this.temporalInsurancePayments.set([]);
  }

  handleDownloadJson() {
    const customer = this.quoteService.formData?.customer || null;
    const financialProduct = this.form.getRawValue().financialSetup?.financialProduct;
    const eligible = isLifeInsuranceEligible(
      customer?.personType,
      financialProduct,
    );
    const premium = eligible
      ? resolveFinancedUnitInsurancePremium(
          this.form.controls['insurance']?.value
        )
      : null;
    let model = new BodyCalculate(
      this.form.getRawValue(),
      this.quoteService.formData,
      this.quoteService.formData?.model || null,
      customer,
      premium,
      this.quoteService.formData?.standardQuoteModel
    );
    model.lifeInsuranceFactor = eligible ? LIFE_INSURANCE_FACTOR : 0;

    this.loading.track(this.quoteService.calculateStandardQuoteOpenJson(model)).subscribe(
      (response) => {
        if (response.status === true) {
          const jsonStr = JSON.stringify(response.data, null, 2);

          const cotizacionFileName = this.idDeal
            ? `CotizacionE(${this.idDeal}).json`
            : 'CotizacionE.json';

          const blob = new Blob([jsonStr], { type: 'application/json' });

          const url = window.URL.createObjectURL(blob);

          const a = document.createElement('a');
          a.href = url;
          a.download = cotizacionFileName;
          document.body.appendChild(a);
          a.click();

          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        } else {
        }
      },
      (error) => {
        console.error('Error al descargar el JSON', error);
      }
    );
  }

  triggerDownloadJson() {
    // this.financialProductComponent.emitFormDataForDownload();
    this.handleDownloadJson();
  }

  canAddInsurance() {
    return true;
  }

  deleteDealPayments(paymentsEvents?: any[]) {
    const payments = this.form.controls['payments'].value || [];
    const effectivePayments = payments.length >= 1 ? payments : paymentsEvents || [];
    const insurance = this.form.controls['insurance'].value;
    const insurancePayments = insurance?.standardQuoteInsurancePayments;
    const { savePayment, saveInsurancePayments } = this.saveTemporalPayments(this.idDeal, insurance?.id, effectivePayments, insurancePayments);
    if (savePayment) {
      this.form.controls['payments'].setValue([]);
    }
    if (saveInsurancePayments) {
      insurance["standardQuoteInsurancePayments"] = [];
      this.form.controls['insurance'].setValue(insurance);
    }
    if (savePayment || saveInsurancePayments) {
      this.showMessageCalculate = true;
      this.form.controls['result'].setValue(null);
      this.form.updateValueAndValidity();
    }
    // this.form.updateValueAndValidity({ onlySelf: true });
  }

  isValid(): boolean {
    const modelValid = this.isModelValid();
    const formValid = this.form.controls['financialSetup'].valid;
    return modelValid && formValid;
  }

  isModelValid(): boolean {
    const model = this.insuranceService.insuranceModel();
    return !!model && !!model.modelCode && !!model.modelType;
  }

  updateInsuranceData(): void {
    const standardModel = this.quoteService.formData?.standardQuoteModel;
    const financialSetup = this.form.controls['financialSetup'].value;
    const financialProduct = financialSetup?.financialProduct;
    const isAF = financialProduct == FinancialProductEnum.financialLeasing;
    const customer = this.normalizeInsuranceCustomer(this.quoteService.formData?.customer);
    const commonInsuranceUpdates = {
      companyName: this.quoteService.formData?.companyName || '',
      financialProduct: isAF ? FinancialProductEnum.directCredit : financialProduct,
      term: this.form.controls['financialCondition'].value?.term,
      oldId: financialSetup?.id || 0,

      dealerBranchId: this.quoteService.formData?.wholeSaleId,
      dealerId: this.quoteService.formData?.dealerId,
      customer,

      currency: this.models?.currency,
      paymentType: financialSetup?.paymentType,
      quantity: this.models?.quantity,
      taxFree: financialSetup?.taxFree === true || financialSetup?.taxFree === "true" || financialSetup?.taxFree === "TRUE" || false,
      customerRate: financialSetup?.nominalRate,
      paymentFormationType: financialSetup?.calculationType,
      openingFeeType: financialSetup?.openingFeeType,
      openingFeePercentage: financialSetup?.openingFeePercentage,
      openingFee: financialSetup?.openingFee,
      downPaymentTaxType: financialSetup?.downPaymentTaxType,
      downPaymentTax: financialSetup?.downPaymentTax,
      downPayment: 0,
      grace: [],
    };
    const modelInsuranceUpdates = {
      classification: Boolean(this.models?.classification),
      modelType: this.models?.modelType,
      modelCode: this.models?.modelCode,
      name: this.models?.name || '',
      year: this.models?.year || 0,
      subBrand: { name: this.models?.subBrand.name },
      price: standardModel ? standardModel.price : this.models?.price || 0,
    };

    // Actualizar los objetos
    this.insuranceService.insuranceParams.update((before) => this.insuranceService.updateMultipleProperties(
      before,
      commonInsuranceUpdates
    ));
    this.insuranceService.insuranceModel.update((before) => this.insuranceService.updateMultipleProperties(before, modelInsuranceUpdates));

  }

  private normalizeInsuranceCustomer(customer?: customerDto | any): customerDto | undefined {
    if (!customer) return customer;
    if (customer.personType !== 'NATURAL_PERSON') return customer;

    const firstName = this.getFirstNonEmptyValue(
      customer.firstName,
      customer.customerName,
      customer.name
    );

    return {
      ...customer,
      firstName,
    };
  }

  private getFirstNonEmptyValue(...values: Array<string | null | undefined>): string | null {
    return values.find((value) => typeof value === 'string' && value.trim() !== '') ?? null;
  }

  get commonInsurance(): ICommonInsuranceParams {
    return this._commonInsurance;
  }

  get modelInsurance(): ICommonModelInsurance {
    return this._modelInsurance;
  }

  get isAvailableInsurancePayments() {
    const insurance = this.form.controls['insurance'].value;
    return insurance && insurance?.standardQuoteInsurancePayments?.length > 0;
  }

  get formQuantity() {
    return this.models?.quantity;
  }

  get formCurrency() {
    return this.models?.currency || "";
  }

  get insurancePayments() {
    const insurance = this.form.controls['insurance'].value;
    return insurance?.standardQuoteInsurancePayments;
  }

  get isDisabledCalculateQuote() {
    const isFinancialSetupInvalid = this.form.controls['financialSetup'].invalid;
    const insurance = this.form.controls['insurance']?.value;
    const isClonedDeal = !!this.quoteService.duplicateDeal;
    const hasInsuranceWithoutId = insurance != null && !insurance?.id;
    const hasInsuranceNotCalculated = insurance != null && !!insurance.id && insurance?.packageList == null;

    // Si está clonada y no se calculó el seguro (no tiene id), deshabilitar
    if (isClonedDeal && hasInsuranceWithoutId) {
      return true;
    }

    // Si el seguro existe pero no está calculado (no tiene packageList), deshabilitar
    if (hasInsuranceWithoutId || hasInsuranceNotCalculated) {
      return true;
    }

    return isFinancialSetupInvalid;
  }
  private areAllRequiredDataReady(): boolean {
    // Verificar formulario válido
    const isFormValid = this.form.controls['financialSetup'].valid &&
      this.form.controls['financialCondition'].valid;

    // Verificar datos del servicio
    const hasModel = !!this.quoteService.formData?.model;
    const hasCustomer = !!this.quoteService.formData?.customer;

    // TODOS los datos deben estar listos, sin excepciones
    return isFormValid && hasModel && hasCustomer;
  }
  private waitForDataAndCalculate(): void {
    if (this._calculationScheduled) {
      return;
    }

    this._calculationScheduled = true;
    let attempts = 0;
    const maxAttempts = 25; // 20 segundos máximo (25 * 0.8s)

    const checkAndCalculate = () => {
      attempts++;
      if (this.areAllRequiredDataReady()) {
        this.calculate();
        return;
      } else if (attempts < maxAttempts) {
        setTimeout(checkAndCalculate, 800);
      } else {
      }
    };
    setTimeout(checkAndCalculate, 200);
  }

  get quoteName() {
    return this.quoteService.formData?.quoteName ?? "";
  }
}
